module.exports = __webpack_public_path__ + "826afab746050c7fcec805e9e2e2f9d5.svg";